import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/6q1wjNGEW9jq6sTQcJHyrg/alisados_2.png', 'https://cdn.magicpatterns.com/uploads/gBSdbCrisdTb5iE8DFXjgJ/alisadso_1.png', 'https://cdn.magicpatterns.com/uploads/mziEkizxGbjQ33BARdzWzx/ALISADOS_4.png', 'https://cdn.magicpatterns.com/uploads/svCGNBcM7xg2jUigp4V81A/alisado_3.png', 'https://cdn.magicpatterns.com/uploads/qZiBP3FpRzw8qbbSANQ2Js/ALISADOS_5.png', 'https://cdn.magicpatterns.com/uploads/qP66vHW7KfRp7MYdoTjXEv/ALISADOS_6.png', 'https://cdn.magicpatterns.com/uploads/2wvpcFfK5yfCSnUeHyhMaE/ALISADOS_7.png'];
export const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextImage = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const prevImage = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  // Auto-scroll the main slider slowly
  useEffect(() => {
    const timer = setInterval(() => {
      nextImage();
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section id="galeria" className="py-20 bg-beige-50 relative overflow-hidden" data-id="element-248">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[radial-gradient(ellipse_at_top,_rgba(201,166,107,0.15),_transparent_70%)] pointer-events-none" data-id="element-249"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-250">
        <div className="text-center mb-12" data-id="element-251">
          <h2 className="gallery-title-eyebrow text-sm tracking-[0.3em] uppercase mb-3 font-[800] text-[#5C4A3A]" data-id="element-252">
            Excelencia Comprobada
          </h2>
          <h3 className="gallery-title-heading text-4xl md:text-5xl lg:text-6xl font-serif text-neutral-900 mb-6" data-id="element-253">
            Nuestros{' '}
            <span className="metallic-gold-text italic gallery-title-shimmer" data-id="element-254">
              Resultados
            </span>
          </h3>
          <div className="gallery-title-rule w-24 h-1 bg-gold-300 mx-auto rounded-full" data-id="element-255"></div>
        </div>

        {/* Main Slider */}
        <div className="relative max-w-4xl mx-auto mb-12" data-id="element-256">
          <div className="relative rounded-[2rem] overflow-hidden border-2 border-gold-300 bg-white shadow-2xl aspect-[3/4] sm:aspect-square md:aspect-[4/5] lg:aspect-[3/4]" data-id="element-257">
            <img src={images[currentIndex]} alt={`Trabajo de alisado ${currentIndex + 1}`} className="w-full h-full object-cover transition-opacity duration-500" data-id="element-258" />

            {/* Controls */}
            <div className="absolute inset-0 flex items-center justify-between p-4" data-id="element-259">
              <button onClick={prevImage} className="w-12 h-12 rounded-full bg-white/80 backdrop-blur-sm border border-gold-300 flex items-center justify-center text-neutral-800 hover:bg-gold-100 transition-all shadow-lg" aria-label="Anterior" data-id="element-260">
                <ChevronLeft size={24} className="metallic-gold-icon" data-id="element-261" />
              </button>
              <button onClick={nextImage} className="w-12 h-12 rounded-full bg-white/80 backdrop-blur-sm border border-gold-300 flex items-center justify-center text-neutral-800 hover:bg-gold-100 transition-all shadow-lg" aria-label="Siguiente" data-id="element-262">
                <ChevronRight size={24} className="metallic-gold-icon" data-id="element-263" />
              </button>
            </div>
          </div>

          {/* Dot indicators */}
          <div className="flex items-center justify-center gap-3 mt-6" data-id="element-264">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} aria-label={`Ver trabajo ${idx + 1}`} className={`rounded-full transition-all duration-300 ${currentIndex === idx ? 'w-8 h-2.5 bg-gold-500' : 'w-2.5 h-2.5 bg-beige-300 hover:bg-gold-300'}`} data-id="element-265" />)}
          </div>
        </div>

        {/* Animated Carousel */}
        <div className="relative w-full overflow-x-hidden overflow-y-visible py-10" data-id="element-266">
          <div className="flex gap-6 animate-scroll w-max items-center" data-id="element-267">
            {/* Double the images to create an infinite loop effect */}
            {[...images, ...images].map((img, idx) => <button key={idx} onClick={() => setCurrentIndex(idx % images.length)} className="carousel-item relative flex-shrink-0 w-40 h-56 sm:w-48 sm:h-64 rounded-2xl overflow-hidden border-2 border-beige-200" style={{
            animationDelay: `${idx % images.length * 0.5}s`
          }} data-id="element-268">
                <img src={img} alt={`Miniatura ${idx + 1}`} className="w-full h-full object-cover" data-id="element-269" />
              </button>)}
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-50% - 0.75rem)); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }

        /* Each image "pops" out above the rest in a travelling wave */
        @keyframes carouselPop {
          0%, 70%, 100% {
            transform: translateY(0) scale(1);
            box-shadow: 0 8px 20px -12px rgba(60, 40, 20, 0.25);
            z-index: 1;
          }
          35% {
            transform: translateY(-22px) scale(1.12);
            box-shadow: 0 26px 40px -16px rgba(60, 40, 20, 0.45);
            z-index: 10;
          }
        }
        .carousel-item {
          position: relative;
          animation: carouselPop 7s ease-in-out infinite;
          will-change: transform;
        }
        .carousel-item:hover {
          z-index: 20;
        }

        /* Title entrance */
        @keyframes galleryRise {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes galleryRule {
          0% { opacity: 0; transform: scaleX(0); }
          100% { opacity: 1; transform: scaleX(1); }
        }
        .gallery-title-eyebrow {
          animation: galleryRise 0.7s ease-out both;
        }
        .gallery-title-heading {
          animation: galleryRise 0.7s ease-out 0.15s both;
        }
        .gallery-title-rule {
          transform-origin: center;
          animation: galleryRule 0.6s ease-out 0.35s both;
        }

        /* Continuous gold shimmer on "Resultados" so motion is always visible */
        @keyframes goldShimmer {
          0%, 100% {
            filter: brightness(1.08) saturate(1.05);
            text-shadow: 0 0 6px rgba(201,166,107,0.35);
          }
          50% {
            filter: brightness(1.45) saturate(1.25);
            text-shadow: 0 0 24px rgba(212,175,90,0.95), 0 0 40px rgba(201,166,107,0.55);
          }
        }
        .gallery-title-shimmer {
          display: inline-block;
          animation: goldShimmer 2.6s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .gallery-title-eyebrow,
          .gallery-title-heading,
          .gallery-title-rule,
          .gallery-title-shimmer,
          .carousel-item {
            animation: none;
          }
        }
      `
    }} data-id="element-270" />
    </section>;
};